import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getTimeline, TimelineResponse } from '@/services/api';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const TimelinePage: React.FC = () => {
  const [from, setFrom] = useState(0);
  const { data, isLoading, error } = useQuery<TimelineResponse>(['timeline', from], () => getTimeline(from, 50));

  const docs = data?.items || [];

  const groups = new Map<string, typeof docs>();
  docs.forEach((doc: any) => {
    const day = doc.doc_date?.split('T')[0] || 'unknown';
    if (!groups.has(day)) groups.set(day, []);
    groups.get(day)!.push(doc);
  });

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="fw-bold mb-0">Лента событий</h4>
        <div className="d-flex align-items-center gap-2">
          <span className="badge bg-success"><i className="bi bi-broadcast me-1"></i>Live</span>
          <button className="btn btn-sm btn-outline-primary"><i className="bi bi-download me-1"></i>Excel</button>
        </div>
      </div>

      {isLoading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
      ) : error ? (
        <div className="alert alert-danger">
          <i className="bi bi-exclamation-triangle me-2"></i>
          Ошибка загрузки: {(error as any)?.message || 'Неизвестная ошибка'}
        </div>
      ) : (
        <div>
          {Array.from(groups.entries())  .sort(([a], [b]) => b.localeCompare(a))  .map(([day, dayDocs]) => (
            <div key={day} className="mb-4">
              <h6 className="text-uppercase text-muted mb-3" style={{ fontSize: '12px', letterSpacing: '1px', fontWeight: 700 }}>
                {day !== 'unknown' ? format(new Date(day), 'd MMMM yyyy, EEEE', { locale: ru }) : 'Без даты'}
              </h6>
              <div className="table-card">
                <div className="table-responsive">
                  <table className="table mb-0">
                    <tbody>
                      {dayDocs.map((doc: any) => (
                        <tr key={doc.id}>
                          <td style={{ width: 40 }}>
                            <button className="btn btn-sm btn-link text-warning p-0"><i className="bi bi-star"></i></button>
                          </td>
                          <td>
                            <Link to={`/document/${doc.id}`} className="text-decoration-none fw-medium">{doc.title}</Link>
                            <div className="small text-muted d-flex gap-2 mt-1">
                              <span className="font-monospace">{doc.eo_number}</span>
                              <span>•</span>
                              <span>{doc.authority}</span>
                            </div>
                          </td>
                          <td style={{ width: 120 }}>
                            <span className={`badge-status badge-${doc.status === 'Опубликован' || doc.status === 'active' ? 'active' : doc.status === 'amended' ? 'amended' : doc.status === 'repealed' ? 'repealed' : 'project'}`}>
                              {doc.status === 'Опубликован' || doc.status === 'active' ? 'Действует' : doc.status === 'amended' ? 'Изменён' : doc.status === 'repealed' ? 'Утратил силу' : 'Проект'}
                            </span>
                          </td>
                          <td style={{ width: 100 }} className="text-end">
                            <button className="btn btn-sm btn-light"><i className="bi bi-eye"></i></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ))}
          <div className="text-center">
            <button className="btn btn-outline-primary" onClick={() => setFrom(from + 50)}>Загрузить ещё</button>
          </div>
        </div>
      )}
    </div>
  );
};